import AssistantKnowledgeBasesAPI from 'dashboard/api/assistant/knowledgeBases';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AssistantKnowledgeBase',
  API: AssistantKnowledgeBasesAPI,
});
